// Define the function globally on the window object
window.triggerContentModulePixel = function(element) {
  
  // 1. Safe extraction of data attributes
  var pixelData = {
    link: element.getAttribute('data-link') || element.getAttribute('href'),
    module_name: element.getAttribute('data-module-name') || 'Unknown Module',
    parent_page: window.location.href.replace(window.location.origin, '')
  };

  console.log('Content module Clicked Fired:', pixelData);

  if(window.Shopify && window.Shopify.analytics) {
    window.Shopify.analytics.publish("content_module_clicked", pixelData);
  }
};
